import { Pipe, PipeTransform } from '@angular/core';
import { PricePipe } from '../price/price.pipe';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth/auth.service';

@Pipe({
  name: 'priceInWords',
  pure: false
})
export class PriceInWordsPipe implements PipeTransform {
  constructor(private pricePipe: PricePipe,
              private translateService: TranslateService,
              private authService: AuthService) {}

  transform (value: number = 0) {
    const num: string[] = this.pricePipe.transform(value, true).split('.');
    return this.convert(num[0]) + ' ' + this.authService.currencySymbol + ' ' + this.convert(Number(num[1]).toString()) + ' ' + this.authService.currencyCent;
  }

  convert (string: string) {
    let units, tens, scales, start, end, chunks, chunksLen, chunk, ints, i, word, words;

    /* Is number zero? */
    if (parseInt(string, 0) === 0) {
      return this.translateService.instant('general.number_in_words_zero');
    }

    /* Array of units as words */
    units = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];

    /* Array of tens as words */
    tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    /* Array of scales as words */
    scales = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion', 'decillion', 'undecillion', 'duodecillion', 'tredecillion', 'quatttuor-decillion', 'quindecillion', 'sexdecillion', 'septen-decillion', 'octodecillion', 'novemdecillion', 'vigintillion', 'centillion'];

    /* Split user argument into 3 digit chunks from right to left */
    start = string.length;
    chunks = [];
    while (start > 0) {
      end = start;
      chunks.push(string.slice((start = Math.max(0, start - 3)), end));
    }

    /* Check if function has enough scale words to be able to stringify the user argument */
    chunksLen = chunks.length;
    if (chunksLen > scales.length) {
      return '';
    }

    /* Stringify each integer in each chunk */
    words = [];
    for (i = 0; i < chunksLen; i++) {
      chunk = parseInt(chunks[i], 0);
      if (chunk) {
        /* Split chunk into array of individual integers */
        ints = chunks[i].split('').reverse().map(parseFloat);

        /* If tens integer is 1, i.e. 10, then add 10 to units integer */
        if (ints[1] === 1) {
          ints[0] += 10;
        }

        /* Add scale word if chunk is not zero and array item exists */
        if ((word = scales[i])) {
          words.push(this.translateService.instant('general.number_in_words_' + word));
        }

        /* Add unit word if array item exists */
        if ((word = units[ints[0]])) {
          words.push(this.translateService.instant('general.number_in_words_' + word));
        }

        /* Add tens word if array item exists */
        if ((word = tens[ints[1]])) {
          words.push(this.translateService.instant('general.number_in_words_' + word));
        }

        /* Add hundreds word if array item exists */
        if ((word = units[ints[2]])) {
          words.push(this.translateService.instant('general.number_in_words_' + word) + ' ' + this.translateService.instant('general.number_in_words_hundred'));
        }
      }
    }
    return words.reverse().join(' ');
  }
}
